import React from "react";
import { clone, isEmpty, isNil } from "ramda";
import {
  Button,
  Checkbox,
  Collapse,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  TextField,
} from "@mui/material";
import palette from "../../../../config/colorPalette";
import { ErrorText } from "../styled";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import {
  handleActiveThresholds,
  handleZones,
  maxHandler,
  minHandler,
  onBlurHandler,
  onValueChangeHandler,
} from "../utils/utils";
import { getAlertTypeNames } from "../../../utils/utils";

const MeasurementInfo = ({
  currentEquipmentType,
  asignedChannelNames,
  measure,
  measureIndex,
  measureToggle,
  setMeasureToggle,
  measuresAlerts,
  setMeasuresAlerts,
  thresholdsRanges,
  setThresholdsRanges,
  chunk,
  channelToggle,
  tuples,
  setTuples,
  setChannelToggle,
  tuplesActive,
  setTuplesActive,
  zoneToggle,
  setZoneToggle,
  errors,
  setErrors,
  intl,
}) => {
  const handleCloseMeasurement = (channelToggle, setChannelToggle, measureIndex, channelIndex) => {
    let newChannelToggle = clone(channelToggle);
    if (newChannelToggle[measureIndex][channelIndex]) {
      newChannelToggle[measureIndex][channelIndex] = false;
    } else {
      newChannelToggle[measureIndex][channelIndex] = true;
    }
    setChannelToggle(newChannelToggle);
  };

  if (!isNil(currentEquipmentType) && currentEquipmentType[0].computing.includes(measure)) {
    return null;
  }
  return (
    <>
      <div style={{ fontSize: "x-large", display: "flex", alignItems: "center" }}>
        <div
          onClick={() => {
            let newMeasureToggle = clone(measureToggle);
            if (newMeasureToggle[measureIndex]) {
              newMeasureToggle[measureIndex] = false;
            } else {
              newMeasureToggle[measureIndex] = true;
            }
            setMeasureToggle(newMeasureToggle);
          }}
        >
          {intl.formatMessage({ id: measure })}{" "}
          {!measureToggle[measureIndex] ? <ArrowDropDownIcon /> : <ArrowDropUpIcon />}
        </div>
        <div>
          <FormControlLabel
            control={
              <Checkbox
                id={"checkbox" + measureIndex}
                sx={{
                  color: palette.primary,
                  "&.Mui-checked": {
                    color: palette.primary,
                  },
                }}
                checked={measuresAlerts[measureIndex] === 1 ? true : false}
                onChange={(e) => {
                  let newMA = clone(measuresAlerts);
                  if (e.target.checked) {
                    newMA[measureIndex] = 1;
                  } else {
                    newMA[measureIndex] = 0;
                  }
                  setMeasuresAlerts(newMA);
                }}
              />
            }
            label={intl.formatMessage({ id: "send.alert" })}
            style={{ marginLeft: "auto" }}
          />
        </div>
      </div>

      {!isNil(measureToggle[measureIndex]) && (
        <Collapse in={measureToggle[measureIndex]}>
          <table style={{ borderCollapse: "collapse", border: "none" }}>
            <tbody>
              {thresholdsRanges.length > 0 &&
                chunk(thresholdsRanges[measureIndex], 10).map((channelGroup, rowIndex) => (
                  <tr key={`row-${rowIndex}-measurement`} style={{ borderCollapse: "collapse", border: "none" }}>
                    {channelGroup.map((channel, groupIndex) => {
                      const channelIndex = rowIndex * 10 + groupIndex;

                      return (
                        <td style={{ borderCollapse: "collapse", border: "none" }}>
                          <Button
                            id={`channel_measurement${channelIndex}_collapse`}
                            variant="contained"
                            style={{ margin: "5%", backgroundColor: palette.secondary, color: "white" }}
                            onClick={() => {
                              handleCloseMeasurement(channelToggle, setChannelToggle, measureIndex, channelIndex);
                            }}
                          >
                            {asignedChannelNames[channelIndex]}-{intl.formatMessage({ id: "channel.mayus" })}{" "}
                            {channelIndex + 1}{" "}
                          </Button>

                          {!isNil(channelToggle[measureIndex]) && (
                            <Dialog
                              maxWidth="lg"
                              open={channelToggle[measureIndex][channelIndex]}
                              onClose={() =>
                                handleCloseMeasurement(channelToggle, setChannelToggle, measureIndex, channelIndex)
                              }
                            >
                              <DialogTitle
                                style={{
                                  fontSize: "x-large",
                                  color: palette.primary,
                                  fontWeight: "600",
                                }}
                              >
                                {asignedChannelNames[channelIndex]}-{intl.formatMessage({ id: "channel.mayus" })}{" "}
                                {channelIndex + 1}{" "}
                              </DialogTitle>
                              <DialogContent>
                                <table style={{ borderCollapse: "collapse" }}>
                                  <tr>
                                    <th rowspan="2">
                                      <TextField
                                        id={`zone_addition${measureIndex}_${channelIndex}`}
                                        style={{ margin: "0.8rem 0.2rem 0.8rem" }}
                                        defaultValue={thresholdsRanges[measureIndex][channelIndex].length}
                                        inputProps={{ min: 1 }}
                                        onChange={(e) => {
                                          handleZones({
                                            e,
                                            tuples,
                                            channelIndex,
                                            errors,
                                            measureIndex,
                                            setErrors,
                                            setThresholdsRanges,
                                            setTuples,
                                            thresholdsRanges,
                                            tuplesActive,
                                            setTuplesActive,
                                            zoneToggle,
                                            setZoneToggle,
                                          });
                                        }}
                                        type="number"
                                        error={errors[`zone_addition${measureIndex}_${channelIndex}`] ? true : false}
                                        variant="outlined"
                                        label={intl.formatMessage({ id: "measure.zones" })}
                                        required
                                        sx={{ width: "40%" }}
                                      ></TextField>
                                    </th>
                                    <th rowspan="2">
                                      <h2>{intl.formatMessage({ id: "range.min" })}</h2>
                                    </th>
                                    <th rowspan="2">
                                      <h2>{intl.formatMessage({ id: "range.max" })}</h2>
                                    </th>
                                    <th colspan="3">
                                      <h3>{intl.formatMessage({ id: "thresholds" })}</h3>
                                    </th>
                                  </tr>
                                  <tr>
                                    <th>
                                      <h3>{intl.formatMessage({ id: "low" })}</h3>
                                    </th>
                                    <th>
                                      <h3>{intl.formatMessage({ id: "intermediate" })}</h3>
                                    </th>
                                    <th>
                                      <h3>{intl.formatMessage({ id: "high" })}</h3>
                                    </th>
                                  </tr>
                                  {thresholdsRanges[measureIndex][channelIndex].map((zone, zoneIndex) => {
                                    const parts = thresholdsRanges[measureIndex][channelIndex][zoneIndex].split("-");

                                    const num1 = parseInt(parts[0], 10);
                                    const num2 = parseInt(parts[1], 10);

                                    const bounds = getAlertTypeNames(intl);

                                    if (tuples[measureIndex][channelIndex][zoneIndex].length < 3) {
                                      bounds.splice(
                                        0,
                                        tuples[measureIndex][channelIndex][zoneIndex].length === 2 ? 1 : 2,
                                      );
                                    }
                                    return (
                                      <tr className="channel_row">
                                        <td>
                                          <center>
                                            <h2>
                                              {intl.formatMessage({ id: "zone" })} {zoneIndex + 1}
                                            </h2>
                                          </center>
                                        </td>
                                        <td className="input">
                                          <center>
                                            <div className="input-wrapper">
                                              <div className="input-row">
                                                <TextField
                                                  type="number"
                                                  variant="outlined"
                                                  sx={{ width: "50%" }}
                                                  key={`equipment_${measureIndex}_${channelIndex}_${zoneIndex}_0`}
                                                  error={
                                                    errors[`equipment_${measureIndex}_${channelIndex}_${zoneIndex}_0`]
                                                      ? true
                                                      : false
                                                  }
                                                  value={num1}
                                                  onChange={(e) => {
                                                    minHandler({
                                                      e,
                                                      num1,
                                                      num2,
                                                      thresholdsRanges,
                                                      setThresholdsRanges,
                                                      measureIndex,
                                                      channelIndex,
                                                      zoneIndex,
                                                      errors,
                                                      setErrors,
                                                    });
                                                  }}
                                                />
                                              </div>
                                              {!isNil(
                                                errors[`equipment_${measureIndex}_${channelIndex}_${zoneIndex}_0`],
                                              ) && (
                                                <ErrorText className="error-message">
                                                  {intl.formatMessage({
                                                    id: errors[
                                                      `equipment_${measureIndex}_${channelIndex}_${zoneIndex}_0`
                                                    ],
                                                  })}
                                                </ErrorText>
                                              )}
                                            </div>
                                          </center>
                                        </td>
                                        <td item xs={1} className="input">
                                          <center>
                                            <div className="input-wrapper">
                                              <div className="input-row">
                                                <TextField
                                                  sx={{ width: "50%" }}
                                                  key={`equipment_${measureIndex}_${channelIndex}_${zoneIndex}_1`}
                                                  type="number"
                                                  variant="outlined"
                                                  value={num2}
                                                  error={
                                                    errors[`equipment_${measureIndex}_${channelIndex}_${zoneIndex}_1`]
                                                      ? true
                                                      : false
                                                  }
                                                  onChange={(e) => {
                                                    maxHandler({
                                                      e,
                                                      num1,
                                                      num2,
                                                      thresholdsRanges,
                                                      setThresholdsRanges,
                                                      measureIndex,
                                                      channelIndex,
                                                      zoneIndex,
                                                      errors,
                                                      setErrors,
                                                    });
                                                  }}
                                                />
                                              </div>
                                              {!isNil(
                                                errors[`equipment_${measureIndex}_${channelIndex}_${zoneIndex}_1`],
                                              ) && (
                                                <ErrorText className="error-message">
                                                  {intl.formatMessage({
                                                    id: errors[
                                                      `equipment_${measureIndex}_${channelIndex}_${zoneIndex}_1`
                                                    ],
                                                  })}
                                                </ErrorText>
                                              )}
                                            </div>
                                          </center>
                                        </td>
                                        {tuples[measureIndex][channelIndex][zoneIndex].map((threshValue, index2) => (
                                          <>
                                            <td className="input">
                                              <center>
                                                <div className="input-wrapper">
                                                  <div className="input-row">
                                                    <TextField
                                                      id={measure + measureIndex + threshValue}
                                                      sx={{ width: "50%" }}
                                                      inputProps={{ step: "0.1" }}
                                                      value={threshValue}
                                                      disabled={
                                                        tuplesActive[measureIndex][channelIndex][zoneIndex][index2] !==
                                                        1
                                                      }
                                                      onChange={(e) =>
                                                        onValueChangeHandler({
                                                          value: !isEmpty(e.target.value)
                                                            ? parseFloat(e.target.value)
                                                            : null,
                                                          measureIndex,
                                                          channelIndex,
                                                          zoneIndex,
                                                          index2,
                                                          tuples,
                                                          setTuples,
                                                          tuplesActive,
                                                          setTuplesActive,
                                                        })
                                                      }
                                                      error={
                                                        errors[
                                                          `threshold-${measureIndex}-${channelIndex}-${zoneIndex}-value-${index2}`
                                                        ]
                                                          ? true
                                                          : false
                                                      }
                                                      onBlur={() =>
                                                        onBlurHandler({
                                                          idErrorPrefix: `threshold-${measureIndex}-${channelIndex}-${zoneIndex}-value`,
                                                          measureIndex,
                                                          channelIndex,
                                                          zoneIndex,
                                                          tuples,
                                                          errors,
                                                          setErrors,
                                                          setTuples,
                                                          tuplesActive,
                                                          setTuplesActive,
                                                          intl,
                                                        })
                                                      }
                                                      type="number"
                                                      variant="outlined"
                                                      required
                                                    />
                                                    <Checkbox
                                                      id={measure + measureIndex + threshValue + "_checkbox"}
                                                      sx={{
                                                        color: palette.primary,
                                                        "&.Mui-checked": {
                                                          color: palette.primary,
                                                        },
                                                      }}
                                                      checked={
                                                        tuplesActive[measureIndex][channelIndex][zoneIndex][index2] ===
                                                        1
                                                      }
                                                      onChange={(event) => {
                                                        handleActiveThresholds({
                                                          event,
                                                          channelIndex,
                                                          index2,
                                                          measureIndex,
                                                          setTuples,
                                                          setTuplesActive,
                                                          tuples,
                                                          tuplesActive,
                                                          zoneIndex,
                                                        });
                                                      }}
                                                    />
                                                  </div>
                                                  {errors[
                                                    `threshold-${measureIndex}-${channelIndex}-${zoneIndex}-value-${index2}`
                                                  ] && (
                                                    <ErrorText className="error-message">
                                                      {intl.formatMessage({
                                                        id: errors[
                                                          `threshold-${measureIndex}-${channelIndex}-${zoneIndex}-value-${index2}`
                                                        ],
                                                      })}
                                                    </ErrorText>
                                                  )}
                                                </div>
                                              </center>
                                            </td>
                                          </>
                                        ))}
                                      </tr>
                                    );
                                  })}
                                </table>
                              </DialogContent>
                              <DialogActions>
                                <Button
                                  variant="contained"
                                  style={{ backgroundColor: palette.secondary, color: "white" }}
                                  onClick={() =>
                                    handleCloseMeasurement(channelToggle, setChannelToggle, measureIndex, channelIndex)
                                  }
                                >
                                  {intl.formatMessage({ id: "accept" })}
                                </Button>
                              </DialogActions>
                            </Dialog>
                          )}
                        </td>
                      );
                    })}
                  </tr>
                ))}
            </tbody>
          </table>
        </Collapse>
      )}
    </>
  );
};

export default MeasurementInfo;
